import { memberState } from "../../../state/atoms";
import { useRecoilState } from "recoil";
import AccountsApi from "../../../api/AccountsApi";
import { PriceDto, SubStatusDtoAddonsCycleEnum } from "../../../generated/account-client";
import { useEffect, useState } from "react";
import { MemberDtoPlanEnum } from "../../../generated/dashboard-client";

export default function LocationPriceText() {
  const [member] = useRecoilState(memberState);
  const [prices, setPrices] = useState<PriceDto[]>([]);
  const [priceLoaded, setPriceLoaded] = useState(false);
  const [locationPrice, setLocationPrice] = useState(0);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [annuallyPrice, setAnnuallyPrice] = useState(0);
  const [annual, setAnnual] = useState(false);

  useEffect(() => {
    if (!member.id) return;
    AccountsApi.getAvailablePrices(member.id).then(resp => setPrices(resp.data));
  }, [member.id]);

  useEffect(() => {
    if (!prices || !prices.length) return;
    setMonthlyPrice(prices.find(it => it.type === 'MONTHLY')?.total || 0);
    setAnnuallyPrice((prices.find(it => it.type === 'ANNUALLY')?.total || 0) / 12);
  }, [prices]);

  useEffect(() => {
    if (!member.id) return;
    if (member.plan === MemberDtoPlanEnum.Free) {
      setAnnual(true);
      setLocationPrice(annuallyPrice);
      setPriceLoaded(true);
    } else {
      AccountsApi.getSubscription(member.id)
        .then((resp) => {
          if (resp.data.addonsCycle === SubStatusDtoAddonsCycleEnum.Monthly) {
            setLocationPrice(monthlyPrice);
            setAnnual(false);
          } else {
            setAnnual(true);
            setLocationPrice(annuallyPrice);
          }
          setPriceLoaded(true);
        });
    }
  }, [member.id, member.plan, annuallyPrice, monthlyPrice]);

  return <>
    {priceLoaded && !!locationPrice && <p>
      Manage all your storefronts and brands from a single account. ${locationPrice}/mo per location{annual ? ", based on annual contract" : ""}.
    </p>}
  </>;
}
